import { useContext } from 'react';
import { Flex, Modal, ModalContext, Text } from 'dash-ui';

import { MarketAreaModals } from 'pages/market-areas/MarketAreasPage.constants';
import { useTranslation } from 'react-i18next';
import { GetMarketAreasDocument, useDeleteMarketAreaMutation, useGetPropertiesQuery } from 'gql/generated.graphql';

function DeleteMarketAreaModal() {
  const { toggleModal, payload, isOpenCurrent } = useContext(ModalContext);
  const { t } = useTranslation();
  const { t: tModal } = useTranslation('common', {
    keyPrefix: 'modalDelete',
  });
  const { t: tLabels } = useTranslation('common', {
    keyPrefix: 'labels',
  });
  const { data, loading: propertiesLoading } = useGetPropertiesQuery({
    variables: {
      pagination: { allowLimit: false },
      filter: { marketAreaIds: [payload?.marketAreaId] },
    },
  });

  const properties = data?.getProperties.collection || [];

  const [deleteMarketArea, { loading }] = useDeleteMarketAreaMutation({
    refetchQueries: [GetMarketAreasDocument],
  });

  async function submitMarketAreaDelete() {
    const { marketAreaId } = payload;
    await deleteMarketArea({ variables: { marketAreaId } });
  }

  const isOpen = isOpenCurrent[MarketAreaModals.DELETE_MARKET_AREA_MODAL];

  function submitModal() {
    toggleModal(false, MarketAreaModals.DELETE_MARKET_AREA_MODAL);
    if (properties.length) {
      toggleModal(true, MarketAreaModals.CONFIRMATION_DELETE_MARKET_AREA_MODAL);
    } else {
      submitMarketAreaDelete();
    }
  }

  function closeModal() {
    toggleModal(false, MarketAreaModals.DELETE_MARKET_AREA_MODAL);
  }

  return (
    <Modal
      isOpen={isOpen}
      title={tModal('title', { entity: 'Market Area' }) || ''}
      children={
        <Flex flexDirection="column">
          <Text>
            {tModal('confirmationText') || ''} <strong>{payload?.marketAreaName}</strong> "Market Area"?
          </Text>
          <Text><strong>Note:</strong>{' '}{t('pages:marketAreasPage:deleteMarketAreaModalNote') || ''}</Text>
        </Flex>
      }
      submitButton={{
        title: tLabels`delete`,
        onClick: submitModal,
        colorVariation: 'danger',
        isLoading: loading || propertiesLoading,
      }}
      cancelButton={{
        title: tLabels`cancel`,
        onClick: closeModal,
      }}
    />
  );
}

export default DeleteMarketAreaModal;
